jQuery(document).ready(function () {
  const menuEntries = document.querySelectorAll(
    ".main-navigation li.menu-item-has-children"
  );

  for (let i = 0; i < menuEntries.length; i++) {
    const chevron = menuEntries[i].querySelector(".chevron");
    if (!chevron) continue;

    chevron.addEventListener("click", (e) => {
      // close ohter submenus
      for (let y = 0; y < menuEntries.length; y++) {
        if (menuEntries[y] !== menuEntries[i]) {
          const chevronTemp = menuEntries[y].querySelector(".chevron");
          menuEntries[y].classList.remove("active-menu");

          if (chevronTemp) {
            chevronTemp.classList.remove("top");
            chevronTemp.classList.add("bottom");
          }
        }
      }
    });
  }
});

// (function () {})();
